import React from 'react';
import { Link } from 'react-router-dom';
import Container from './ui/Container';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <h3 className="footer-title">
              <span className="py-text">Py</span>Solutions
            </h3>
            <p className="footer-description">
              Senior-led full-stack engineering studio. We ship production AI products end to end — backend, frontend, AI/ML, cloud, and DevOps.
            </p>
            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/pysolutions-dev"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link social-link-primary"
                aria-label="PySolutions on LinkedIn"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a
                href="https://github.com/PySolutions-dev"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="PySolutions on GitHub"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a
                href="mailto:info@pysolutions.dev"
                className="social-link"
                aria-label="Email PySolutions"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-2 11H5a2 2 0 01-2-2V7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a href="/#ai-agents">AI Agents & RAG</a></li>
              <li><a href="/#full-stack-ai">Full-stack AI Products</a></li>
              <li><a href="/#llm-fine-tuning">LLM Fine-tuning & Eval</a></li>
              <li><a href="/#python-backends">Python Backends & Platform</a></li>
              <li><a href="/#data-iot">Data & IoT Pipelines</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><a href="/#methodology">How we work</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Resources</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About PySolutions</Link></li>
              <li><Link to="/contact">Start a conversation</Link></li>
              <li><a href="/#faq">FAQ</a></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; 2025 PySolutions. All rights reserved.</p>
          <div className="footer-contact">
            <span>Contact:</span>
            <a href="mailto:info@pysolutions.dev">info@pysolutions.dev</a>
            <span>•</span>
            <span>Europe-based, senior-led full-stack AI engineers.</span>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
